var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIcx(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_722_32570)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M9 18C13.9706 18 18 13.9706 18 9C18 4.02944 13.9706 0 9 0C4.02944 0 0 4.02944 0 9C0 13.9706 4.02944 18 9 18Z",
    fill: "#1FC5C9"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6.354 12.6405L7.57125 11.4233C8.10845 11.7406 8.73591 11.8703 9.35489 11.7919C9.97387 11.7135 10.5492 11.4316 10.9904 10.9904C11.4316 10.5492 11.7135 9.97387 11.7919 9.35489C11.8703 8.73591 11.7406 8.10845 11.4233 7.57125L12.6405 6.354C13.2715 7.22083 13.5722 8.28446 13.4886 9.35335C13.4049 10.4222 12.9424 11.4261 12.1843 12.1843C11.4261 12.9424 10.4222 13.4049 9.35335 13.4886C8.28446 13.5722 7.22083 13.2715 6.354 12.6405ZM5.3595 11.646C4.72852 10.7792 4.42778 9.71554 4.51142 8.64665C4.59506 7.57776 5.05759 6.57385 5.81572 5.81572C6.57385 5.05759 7.57776 4.59506 8.64665 4.51142C9.71554 4.42778 10.7792 4.72852 11.646 5.3595L10.4288 6.57675C9.89155 6.25943 9.26409 6.12974 8.64511 6.2081C8.02613 6.28646 7.45077 6.56842 7.00959 7.00959C6.56842 7.45077 6.28646 8.02613 6.2081 8.64511C6.12974 9.26409 6.25943 9.89155 6.57675 10.4288L5.3595 11.646ZM13.5 5.625C13.2016 5.625 12.9155 5.50647 12.7045 5.29549C12.4935 5.08452 12.375 4.79837 12.375 4.5C12.375 4.20163 12.4935 3.91548 12.7045 3.7045C12.9155 3.49353 13.2016 3.375 13.5 3.375C13.7984 3.375 14.0845 3.49353 14.2955 3.7045C14.5065 3.91548 14.625 4.20163 14.625 4.5C14.625 4.79837 14.5065 5.08452 14.2955 5.29549C14.0845 5.50647 13.7984 5.625 13.5 5.625ZM4.5 14.625C4.20163 14.625 3.91548 14.5065 3.7045 14.2955C3.49353 14.0845 3.375 13.7984 3.375 13.5C3.375 13.2016 3.49353 12.9155 3.7045 12.7045C3.91548 12.4935 4.20163 12.375 4.5 12.375C4.79837 12.375 5.08452 12.4935 5.29549 12.7045C5.50647 12.9155 5.625 13.2016 5.625 13.5C5.625 13.7984 5.50647 14.0845 5.29549 14.2955C5.08452 14.5065 4.79837 14.625 4.5 14.625Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_722_32570"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 18,
    height: 18,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcx);
export default __webpack_public_path__ + "static/media/icx.3b911f369e76673ff36b758b1ffa3b39.svg";
export { ForwardRef as ReactComponent };